export type Cast = {
  id: string
  name: string
  title: string
  mutuLine: string
  hue: string
  image: string
}

const CDN = "https://70fy8xbp6b.ufs.sh/f"

export const CAST: Array<Cast> = [
  {
    id: "01",
    name: "Kalki",
    title: "The Pure Flame",
    mutuLine:
      "The prophesied warrior born to end the dark age and cleanse the world of evil.",
    hue: "from-[#3a1f0f] to-[#0a0503]",
    image: `${CDN}/BzM3qquY5hLZVEMZtxGbBsNpgfRrHakELUZ61QjqlmXMSi9Y`,
  },
  {
    id: "02",
    name: "Bhisma",
    title: "The Lone Survivor",
    mutuLine:
      "He has watched everything he loved turn to ash, yet he stands tall as a legend the wasteland simply cannot break.",
    hue: "from-[#1a1a26] to-[#06070b]",
    image: `${CDN}/BzM3qquY5hLZ6tbiWn9UGp9PhNJYoKDfZsFX1CWtbSmVd0Iv`,
  },
  {
    id: "03",
    name: "Ariel",
    title: "Combat Navigator",
    mutuLine:
      "She descends from the stars with a hunter's instinct, scouring a dying Earth for the one thing the colonies lack: hope.",
    hue: "from-[#0f1f3a] to-[#03060a]",
    image: `${CDN}/BzM3qquY5hLZLDPbHYqCzwXFcPYHUx2DeTuSdtyA3vI4q0hs`,
  },
  {
    id: "04",
    name: "Zach",
    title: "System's Engineer",
    mutuLine:
      "He braves the world's most lethal frontiers, knowing that his technical genius is the only thing keeping the mission, and Ariel, alive.",
    hue: "from-[#0f2a1f] to-[#03080a]",
    image: `${CDN}/BzM3qquY5hLZuuCViDfae4spQcO1wdRkFMiYX2V5UJ7gl6r3`,
  },
  {
    id: "05",
    name: "King Yama",
    title: "Tyrant",
    mutuLine:
      "He's a ruthless ruler who believes absolute control is the only way to preserve his legacy.",
    hue: "from-[#2a0808] to-[#0a0203]",
    image: `${CDN}/BzM3qquY5hLZaGsXHm61SheGWP7DmICtuwA5r4bUXnVyZ2jq`,
  },
  {
    id: "06",
    name: "Queen Mara",
    title: "Discarded Queen",
    mutuLine:
      "A shamed queen and fierce protector using her brilliant mind to save her family.",
    hue: "from-[#1a0f2a] to-[#06030a]",
    image: `${CDN}/BzM3qquY5hLZ8t577wArVQWod7GUKpjsamlI6ki9wLHCD2h3`,
  },
  {
    id: "07",
    name: "Barastyr",
    title: "The Rotten Heir",
    mutuLine:
      "An unstable and entitled prince whose deep insecurities make him dangerously unpredictable.",
    hue: "from-[#2a1f08] to-[#0a0703]",
    image: `${CDN}/BzM3qquY5hLZwynl57aR41nNHWGrw8Z6E9ktoaBhqgjyxMsC`,
  },
  {
    id: "08",
    name: "Kaal",
    title: "Ex-Commander",
    mutuLine:
      "A powerful, mute mutant commander who speaks through brutal strength and unwavering loyalty.",
    hue: "from-[#1a1a1a] to-[#050505]",
    image: `${CDN}/BzM3qquY5hLZBEcOAPuY5hLZKnVq28WivNrfG7EIHaQk4lxy`,
  },
  {
    id: "09",
    name: "Drona",
    title: "The Mentor",
    mutuLine:
      "He'll stop at nothing to forge a warrior capable of purging the world of all evil.",
    hue: "from-[#1f2a1f] to-[#06080a]",
    image: `${CDN}/BzM3qquY5hLZcpIFU0CIC6mdFl0HiuWPaXK9wMYRAtVvNzJh`,
  },
  {
    id: "10",
    name: "Astronaut Pun",
    title: "Astronaut",
    mutuLine:
      "The maternal yet unflinching medic who is willing to sacrifice all for what she loves.",
    hue: "from-[#0f2a2a] to-[#03080a]",
    image: `${CDN}/BzM3qquY5hLZhX0AnCVelw1RnfpMGCxuWjmgAKYqdOXQbB4H`,
  },
]
